import { ActionStatus } from '@parapet/common';
import {
  SET_AUTH_TOKEN,
  AUTH_USER,
  AUTH_COMPANY_USER,
  LOG_OUT_USER,
  SET_AUTH_STATUS,
  AUTH_COMPANY_USER_SUCCESS,
} from './types';

export const setAuthToken = (token: string) => ({
  type: SET_AUTH_TOKEN,
  token,
});

export const authUser = (data: {
  email: string;
  phone: string;
  password: string;
  authType: 'email' | 'phone';
  company?: string;
  callback?: string;
}) => ({
  type: AUTH_USER,
  email: data.email,
  phone: data.phone,
  password: data.password,
  authType: data.authType,
  company: data.company,
  callback: data.callback,
});

export const authCompanyUser = (form: {
  email: string;
  password: string;
  company: string;
  callback: string;
}) => ({
  type: AUTH_COMPANY_USER,
  email: form.email,
  password: form.password,
  company: form.company,
  callback: form.callback,
});

export const authCompanyUserSuccess = (url: string) => ({
  type: AUTH_COMPANY_USER_SUCCESS,
  url,
});

export const authUserFailure = () => ({
  type: SET_AUTH_STATUS,
  status: ActionStatus.failure,
});

export const logOutUser = () => ({
  type: LOG_OUT_USER,
});

export const setAuthStatus = (status: ActionStatus) => ({
  type: SET_AUTH_STATUS,
  status,
});
